<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>北航道南塔新风阀</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-sb10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSB10" class="state-info right-pos sign-container">
                <p class="segment-name">SB10梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassSB10" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sb7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSB7" class="state-info right-pos sign-container">
                <p class="segment-name">SB7梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassSB7" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sb4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSB4" class="state-info right-pos sign-container">
                <p class="segment-name">SB4梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassSB4" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sb1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSB1" class="state-info right-pos sign-container">
                <p class="segment-name">SB1梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassSB1" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSZ1" class="state-info left-pos sign-container">
                <p class="segment-name">SZ1梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassSZ1" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSZ4" class="state-info left-pos sign-container">
                <p class="segment-name">SZ4梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassSZ4" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSZ7" class="state-info left-pos sign-container">
                <p class="segment-name">SZ7梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassSZ7" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSZ10" class="state-info left-pos sign-container">
                <p class="segment-name">SZ10梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassSZ10" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSZ13" class="state-info left-pos sign-container">
                <p class="segment-name">SZ13梁段</p>
                <p>
                  <span>新风阀</span>
                  <span :class="valveClassSZ13" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>北航道南塔排气阀</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-sb12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNB12, humidityAllowedMaxNB12) }}
              </div>
              <div :class="errorSB12" class="state-info right-pos sign-container">
                <p class="segment-name">SB12梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassSB12" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sb9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSB9" class="state-info right-pos sign-container">
                <p class="segment-name">SB9梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassSB9" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sb6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSB6" class="state-info right-pos sign-container">
                <p class="segment-name">SB6梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassSB6" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sb3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSB3" class="state-info right-pos sign-container">
                <p class="segment-name">SB3梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassSB3" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-s01">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorS01" class="state-info right-pos sign-container">
                <p class="segment-name">S01梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassS01" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSZ3" class="state-info left-pos sign-container">
                <p class="segment-name">SZ3梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassSZ3" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSZ6" class="state-info left-pos sign-container">
                <p class="segment-name">SZ6梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassSZ6" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSZ9" class="state-info left-pos sign-container">
                <p class="segment-name">SZ9梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassSZ9" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-sz12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">{{}}</div>
              <div :class="errorSZ12" class="state-info left-pos sign-container">
                <p class="segment-name">SZ12梁段</p>
                <p>
                  <span>排气阀</span>
                  <span :class="valveClassSZ12" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "airValve",
  data() {
    return {
      loading: true,
      timer: null,

      valveClassSB12: "",
      valveClassSB10: "",
      valveClassSB9: "",
      valveClassSB7: "",
      valveClassSB6: "",
      valveClassSB4: "",
      valveClassSB3: "",
      valveClassSB1: "",
      valveClassS01: "",
      valveClassSZ1: "",
      valveClassSZ3: "",
      valveClassSZ4: "",
      valveClassSZ6: "",
      valveClassSZ7: "",
      valveClassSZ9: "",
      valveClassSZ10: "",
      valveClassSZ12: "",
      valveClassSZ13: "",

      errorSB12: "",
      errorSB10: "",
      errorSB9: "",
      errorSB7: "",
      errorSB6: "",
      errorSB4: "",
      errorSB3: "",
      errorSB1: "",
      errorS01: "",
      errorSZ1: "",
      errorSZ3: "",
      errorSZ4: "",
      errorSZ6: "",
      errorSZ7: "",
      errorSZ9: "",
      errorSZ10: "",
      errorSZ12: "",
      errorSZ13: "",

      dataNameIdDict: {
        valveClassSB12: "e141d938-d1f8-449c-81bc-2914d9fba2d9",
        valveClassSB10: "1853415c-fe14-4d91-b354-d802f5d1b97b",
        valveClassSB9: "45c40ab9-2b53-410b-803e-8611ca1e4c4e",
        valveClassSB7: "61a3a2cb-b896-48da-ab43-8ff639767cb8",
        valveClassSB6: "fdcfa06c-3ced-4249-904b-63c4c1da3823",
        valveClassSB4: "15cc7233-256a-46dc-beb1-9e797fbf594a",
        valveClassSB3: "c5c80729-be08-4ae7-a0e5-a430d7cc67b2",
        valveClassSB1: "89eda93d-20bb-4445-991d-e65a46580d49",
        valveClassS01: "a4c4a0a0-5724-4c23-ab77-81ae1a9ec254",
        valveClassSZ1: "c229db0c-0655-4b5c-b4dc-955a60a644f9",
        valveClassSZ3: "0908eb87-2d8b-4207-b2bd-94c2b546df6e",
        valveClassSZ4: "4f270fbe-da59-4101-bb67-711f4bcdc5c1",
        valveClassSZ6: "ffebf72e-7f07-4076-93d3-a3511b44e60f",
        valveClassSZ7: "30514706-b828-4e78-8873-f492112dcdc1",
        valveClassSZ9: "4141698b-0c18-471f-b0bf-8dc5fabf0ca9",
        valveClassSZ10: "c44ac91e-ddb8-4bb4-82d5-7dc0594fcdc0",
        valveClassSZ12: "19deabc9-15eb-4241-9f8f-1cedcdea11ed",
        valveClassSZ13: "6afbabaa-17a7-4a09-bc5e-18aa9b219eea",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxNN1Dehumidifier: "ca13a89c-9a39-4a28-8356-51f58982e30a",
        humidityAllowedMaxNN2Dehumidifier: "764709cd-f38e-410d-93c6-4e6d402919c1",
        humidityAllowedMaxNN3Dehumidifier: "4cc3af06-4e3e-4daa-8dbe-f019ae49a73d",
        humidityAllowedMaxNN4Dehumidifier: "b288e941-56f5-45e5-b0d0-1cb6f25f3a50",
        humidityAllowedMaxNT1Dehumidifier: "16198424-bc59-4d5c-aabb-031cb783288d",
        humidityAllowedMaxN04: "bf13765e-b024-42e6-8c0f-f1656945096f",
        humidityAllowedMaxNB12: "b617c5e1-7bef-464f-962f-ff9714ac004a",
        humidityAllowedMaxNB8: "eefa73f3-2030-445d-9fdd-29e0edab2d55",
        humidityAllowedMaxNB5: "10ade259-104c-487a-b3d7-33227ffb5005",
        humidityAllowedMaxNB2: "f66f9d29-20a5-4ad5-a5d1-0c2931db7832",
        humidityAllowedMaxNZ1: "1201b049-777d-4337-bd8d-0cb9b970c15e",
        humidityAllowedMaxNZ5: "0a09b5b0-8441-4218-b9ad-5850f64a83a5",
        humidityAllowedMaxNZ8: "47fb3abe-699f-4827-bbe6-d36913b94e1b",
        humidityAllowedMaxNZ11: "cde0f349-2ba2-4b21-abc6-b52d0bd576c2",
        humidityAllowedMaxT1: "e6a9e99e-55df-44ad-aa16-e2f8dbf0e7ec",
        humidityAllowedMaxT2: "d5da7010-7036-49dd-b0cd-0908c3199e27",
        humidityAllowedMaxT3: "bcabb070-c6b1-4175-a662-9e7bb499464c",
        humidityAllowedMaxT4: "ed2c0cbd-6ebb-4918-b06a-795ca6e5016c",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        //humidity, temperature
        humidityNN1Dehumidifier: "errorNN1Dehumidifier",
        humidityNN2Dehumidifier: "errorNN2Dehumidifier",
        humidityNN3Dehumidifier: "errorNN3Dehumidifier",
        humidityNN4Dehumidifier: "errorNN4Dehumidifier",
        humidityNT1Dehumidifier: "errorNT1Dehumidifier",
        temperatureNN1Dehumidifier: "errorNN1Dehumidifier",
        temperatureNN2Dehumidifier: "errorNN2Dehumidifier",
        temperatureNN3Dehumidifier: "errorNN3Dehumidifier",
        temperatureNN4Dehumidifier: "errorNN4Dehumidifier",
        temperatureNT1Dehumidifier: "errorNT1Dehumidifier",

        humidityN04: "errorN04",
        humidityNB12: "errorNB12",
        humidityNB8: "errorNB8",
        humidityNB5: "errorNB5",
        humidityNB2: "errorNB2",
        humidityNZ1: "errorNZ1",
        humidityNZ5: "errorNZ5",
        humidityNZ8: "errorNZ8",
        humidityNZ11: "errorNZ11",
        humidityT1: "errorT1",
        humidityT2: "errorT2",
        humidityT3: "errorT3",
        humidityT4: "errorT4",
        temperatureN04: "errorN04",
        temperatureNB12: "errorNB12",
        temperatureNB8: "errorNB8",
        temperatureNB5: "errorNB5",
        temperatureNB2: "errorNB2",
        temperatureNZ1: "errorNZ1",
        temperatureNZ5: "errorNZ5",
        temperatureNZ8: "errorNZ8",
        temperatureNZ11: "errorNZ11",
        temperatureT1: "errorT1",
        temperatureT2: "errorT2",
        temperatureT3: "errorT3",
        temperatureT4: "errorT4",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierNN1: "errorNN1Dehumidifier",
        malfunctionDehumidifierNN2: "errorNN2Dehumidifier",
        malfunctionDehumidifierNN3: "errorNN3Dehumidifier",
        malfunctionDehumidifierNN4: "errorNN4Dehumidifier",
        malfunctionDehumidifierNT1: "errorNT1Dehumidifier",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityNN1Dehumidifier: "humidityTooltipErrorNN1Dehumidifier",
        humidityNN2Dehumidifier: "humidityTooltipErrorNN2Dehumidifier",
        humidityNN3Dehumidifier: "humidityTooltipErrorNN3Dehumidifier",
        humidityNN4Dehumidifier: "humidityTooltipErrorNN4Dehumidifier",
        humidityNT1Dehumidifier: "humidityTooltipErrorNT1Dehumidifier",
        humidityN04: "humidityTooltipErrorN04",
        humidityNB12: "humidityTooltipErrorNB12",
        humidityNB8: "humidityTooltipErrorNB8",
        humidityNB5: "humidityTooltipErrorNB5",
        humidityNB2: "humidityTooltipErrorNB2",
        humidityNZ1: "humidityTooltipErrorNZ1",
        humidityNZ5: "humidityTooltipErrorNZ5",
        humidityNZ8: "humidityTooltipErrorNZ8",
        humidityNZ11: "humidityTooltipErrorNZ11",
        humidityT1: "humidityTooltipErrorT1",
        humidityT2: "humidityTooltipErrorT2",
        humidityT3: "humidityTooltipErrorT3",
        humidityT4: "humidityTooltipErrorT4",
      },

      // //running -> running tool tip
      // dataNameRunningTooltipNameDict: {
      //   runningDehumidifierNN1: "runningTooltipNN1",
      //   runningDehumidifierNN2: "runningTooltipNN2",
      //   runningDehumidifierNN3: "runningTooltipNN3",
      //   runningDehumidifierNN4: "runningTooltipNN4",
      //   runningDehumidifierNT1: "runningTooltipNT1",
      // },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierNN1: "runningClassNN1",
        runningDehumidifierNN2: "runningClassNN2",
        runningDehumidifierNN3: "runningClassNN3",
        runningDehumidifierNN4: "runningClassNN4",
        runningDehumidifierNT1: "runningClassNT1",
      },
      stationIdList: ["5d3d3f64-cae8-4216-8fda-cd38c3cbcf1e", "17790481-8c80-4615-9a98-b844013ac9e9"],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-valve-sign-default {
  0% {
    background-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    background-color: #ffff00;
  }
}
@keyframes breathee-remote-in-progress {
  0% {
    border-color: rgba(075, 160, 240, 0.3);
  }
  100% {
    border-color: #4ba0f0;
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 78px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/hangzhouwan/bridgeLine_north.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 255px;
          left: 335px;
        }

        .station-block-right {
          top: 255px;
          left: 843px;
        }

        .station-block-tower {
          top: 230px;
          left: 586px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            & .segment-name {
              font-size: 25px;
              margin-bottom: 4px;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .sta-left-left {
          top: 262px;
          left: 303px;
          &::before {
            bottom: -25px;
            left: 5px;
            width: 50px;
            transform: rotate(-45deg);
          }
          &::after {
            bottom: -43px;
            left: -2px;
          }
          .state-info {
            right: 2px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-left-right {
          top: 262px;
          left: 303px;
          &::before {
            bottom: -25px;
            left: 33px;
            width: 50px;
            transform: rotate(225deg);
          }
          &::after {
            bottom: -43px;
            left: 75px;
          }
          .state-info {
            right: -220px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right-left {
          top: 262px;
          left: 811px;
          &::before {
            bottom: -25px;
            left: 5px;
            width: 50px;
            transform: rotate(-45deg);
          }
          &::after {
            bottom: -43px;
            left: -2px;
          }
          .state-info {
            right: 2px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right-right {
          top: 262px;
          left: 811px;
          &::before {
            bottom: -25px;
            left: 33px;
            width: 50px;
            transform: rotate(225deg);
          }
          &::after {
            bottom: -43px;
            left: 75px;
          }
          .state-info {
            right: -220px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-tower {
          top: 230px;
          left: 590px;
          &::before {
            bottom: 7px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 24px;
            left: -40px;
          }
          .state-info {
            right: 40px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .valve-sign {
          margin-top: auto;
          margin-bottom: auto;
          width: 12px;
          height: 12px;
          background-color: #ffff00;
          animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
          border-radius: 10px;

          &.open {
            background-color: #67dd34;
            animation: none;
          }
          &.closed {
            background-color: #a0a0a0;
            animation: none;
          }
          &.switching {
            background-color: #4ba0f0;
            animation: none;
          }
        }

        .sign-container {
          & > p {
            margin: 0;
            white-space: nowrap;
            white-space: nowrap;
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            &:first-child {
              font-size: 13px;
            }
          }
        }

        .sensor-sb12 {
          top: 260px;
          left: 175px;
          &::before {
            bottom: 60px;
            left: -81px;
            width: 120px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 112px;
            left: -65px;
          }
          .state-info {
            right: 82px;
            top: -97px;
            min-width: 95px;
          }
        }

        .sensor-sb10 {
          top: 260px;
          left: 241px;
          &::before {
            bottom: 89px;
            left: -133px;
            width: 190px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 170px;
            left: -99px;
          }
          .state-info {
            right: 116px;
            top: -155px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sb9 {
          top: 260px;
          left: 272px;
          &::before {
            bottom: 89px;
            left: -133px;
            width: 190px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 170px;
            left: -99px;
          }
          .state-info {
            right: 116px;
            top: -155px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sb7 {
          top: 260px;
          left: 340px;
          &::before {
            bottom: 105px;
            left: -133px;
            width: 210px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 204px;
            left: -78px;
          }
          .state-info {
            right: 95px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sb6 {
          top: 260px;
          left: 370px;
          &::before {
            bottom: 105px;
            left: -133px;
            width: 210px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 204px;
            left: -78px;
          }
          .state-info {
            right: 95px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sb4 {
          top: 260px;
          left: 437px;
          &::before {
            bottom: 122px;
            left: -130px;
            width: 235px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 237px;
            left: -48px;
          }
          .state-info {
            right: 62px;
            top: -222px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sb3 {
          top: 260px;
          left: 468px;
          &::before {
            bottom: 122px;
            left: -130px;
            width: 235px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 237px;
            left: -48px;
          }
          .state-info {
            right: 62px;
            top: -222px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sb1 {
          top: 260px;
          left: 536px;
          &::before {
            bottom: 130px;
            left: -129px;
            width: 250px;
            transform: rotate(85deg);
          }
          &::after {
            bottom: 254px;
            left: -29px;
          }
          .state-info {
            right: 45px;
            top: -239px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-s01 {
          top: 260px;
          left: 590px;
          &::before {
            bottom: 130px;
            left: -129px;
            width: 250px;
            transform: rotate(85deg);
          }
          &::after {
            bottom: 254px;
            left: -29px;
          }
          .state-info {
            right: 45px;
            top: -239px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sz1 {
          top: 260px;
          left: 643px;
          &::before {
            bottom: 130px;
            left: -105px;
            width: 250px;
            transform: rotate(95deg);
          }
          &::after {
            bottom: 254px;
            left: 30px;
          }
          .state-info {
            right: -125px;
            top: -239px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sz3 {
          top: 260px;
          left: 710px;
          &::before {
            bottom: 122px;
            left: -80px;
            width: 240px;
            transform: rotate(105deg);
          }
          &::after {
            bottom: 238px;
            left: 70px;
          }
          .state-info {
            right: -165px;
            top: -223px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sz4 {
          top: 260px;
          left: 742px;
          &::before {
            bottom: 122px;
            left: -80px;
            width: 240px;
            transform: rotate(105deg);
          }
          &::after {
            bottom: 238px;
            left: 70px;
          }
          .state-info {
            right: -165px;
            top: -223px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sz6 {
          top: 260px;
          left: 810px;
          &::before {
            bottom: 105px;
            left: -62px;
            width: 210px;
            transform: rotate(110deg);
          }
          &::after {
            bottom: 204px;
            left: 78px;
          }
          .state-info {
            right: -173px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sz7 {
          top: 260px;
          left: 846px;
          &::before {
            bottom: 105px;
            left: -62px;
            width: 210px;
            transform: rotate(110deg);
          }
          &::after {
            bottom: 204px;
            left: 78px;
          }
          .state-info {
            right: -173px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sz9 {
          top: 260px;
          left: 914px;
          &::before {
            bottom: 89px;
            left: -42px;
            width: 190px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 171px;
            left: 100px;
          }
          .state-info {
            right: -194px;
            top: -156px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sz10 {
          top: 260px;
          left: 946px;
          &::before {
            bottom: 89px;
            left: -42px;
            width: 190px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 171px;
            left: 100px;
          }
          .state-info {
            right: -194px;
            top: -156px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sz12 {
          top: 260px;
          left: 1015px;
          &::before {
            bottom: 60px;
            left: -23px;
            width: 120px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 112px;
            left: 67px;
          }
          .state-info {
            right: -161px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-sz13 {
          top: 260px;
          left: 1050px;
          &::before {
            bottom: 60px;
            left: -23px;
            width: 120px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 112px;
            left: 67px;
          }
          .state-info {
            right: -161px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 95px;
          }
        }

        .sensor-t4 {
          top: 30px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 39px;
            left: -40px;
          }
          .state-info {
            right: 56px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t3 {
          top: 80px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: 0px;
            width: 50px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 39px;
            left: 42px;
          }
          .state-info {
            right: -152px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t2 {
          top: 130px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 39px;
            left: -40px;
          }
          .state-info {
            right: 56px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t1 {
          top: 180px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: 0px;
            width: 50px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 39px;
            left: 42px;
          }
          .state-info {
            right: -152px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
      }
    }
  }
}
</style>